module.exports = __webpack_public_path__ + "static/about_services04-9cfd7e56a46d67c6c528381144836a4e.png";